import { Injectable } from '@angular/core';

export interface ToastInfo {
  header: string;
  body: string;
  delay?: number;
  classname?: string;
  type?: string;
  textOrTpl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastrService {

  toasts: ToastInfo[] = [];

  constructor() { }

  show(textOrTpl: string, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }
}
